import { defineMessages } from '@jutro/locale';

export default defineMessages({
    additionalInfoHeader: {
        id: 'ml.common.component.MLCRAdditionalInformationComponent.additionalInfoHeader',
        defaultMessage: 'Additional Information'
    },
    additionalInfoEmailField: {
        id: 'ml.common.component.MLCRAdditionalInformationComponent.additionalInfoEmailField',
        defaultMessage: 'Email (Optional)'
    },
    emailScriptHeader: {
        id: 'ml.common.component.MLCRAdditionalInformationComponent.Email Script',
        defaultMessage: 'Email Script'
    },
    emailScriptContent: {
        id: 'ml.common.component.MLCRAdditionalInformationComponent.emailScriptContent',
        defaultMessage: 'When you provide your email address, you consent to receiving emails about your online quote and other product information from third parties working for us who we gave your email address.  We do not share our customer’s personal information with unaffiliated third parties for their own direct marketing purposes.  To view our complete Privacy Policy, click on the Privacy Policy link on the bottom of the screen.'
    },
    verifyEmail:{
        id:'ml.common.component.MLCRAdditionalInformationComponent.verifyEmail',
        defaultMessage:"Enter a valid email address"
    },
    invalidEmail:{
        id:'ml.common.component.MLCRAdditionalInformationComponent.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    }
});